<microsec-form-builder
  #fb
  [fields]="fields"
  [shouldShowActionButtons]="true"
  [submitButtonLabel]="!model ? CREATE_LABEL : SAVE_CHANGES_LABEL"
  (submitEvent)="onSubmit($event)" />
